module.exports = __webpack_public_path__ + "img/Group 6828@2x.2ff1d979.jpg";